
import React from "react";
import { useAccountsTable } from "./AccountsTableProvider";
import AccountFormDialog from "./AccountFormDialog";
import DeleteAccountDialog from "./DeleteAccountDialog";
import { Account, LeadAccount, StrategyWithDetails } from "@/types/strategy-types";

interface AccountsDialogsProps {
  leadAccounts: LeadAccount[];
  strategies: StrategyWithDetails[];
  onCreateAccount: (account: Partial<Account>) => Promise<void>;
  onUpdateAccount: (id: string, account: Partial<Account>) => Promise<void>;
  onDeleteAccount: (id: string) => Promise<void>;
  userRole?: string | null;
}

const AccountsDialogs = ({
  leadAccounts,
  strategies,
  onCreateAccount,
  onUpdateAccount,
  onDeleteAccount,
  userRole
}: AccountsDialogsProps) => {
  const {
    isCreateDialogOpen,
    setIsCreateDialogOpen,
    editingAccount,
    setEditingAccount,
    deletingAccount,
    setDeletingAccount
  } = useAccountsTable();

  const handleCloseCreateDialog = () => {
    // Ensure all related states are properly reset
    setIsCreateDialogOpen(false);
  };

  const handleCloseEditDialog = () => {
    // Ensure all related states are properly reset
    setEditingAccount(null);
  };

  const handleCloseDeleteDialog = () => {
    // Ensure all related states are properly reset
    setDeletingAccount(null);
  };

  return (
    <>
      {/* Create Account Dialog */}
      <AccountFormDialog
        isOpen={isCreateDialogOpen}
        onClose={handleCloseCreateDialog}
        onSubmit={onCreateAccount}
        leadAccounts={leadAccounts}
        strategies={strategies}
        userRole={userRole}
      />

      {/* Edit Account Dialog */}
      {editingAccount && (
        <AccountFormDialog
          isOpen={!!editingAccount}
          onClose={handleCloseEditDialog}
          onSubmit={(account) => onUpdateAccount(editingAccount.id, account)}
          initialData={editingAccount}
          leadAccounts={leadAccounts}
          strategies={strategies}
          userRole={userRole}
        />
      )}

      {/* Delete Account Dialog */}
      <DeleteAccountDialog 
        account={deletingAccount} 
        isOpen={!!deletingAccount}
        onClose={handleCloseDeleteDialog}
        onDelete={onDeleteAccount}
      />
    </>
  );
};

export default AccountsDialogs;
